import React from 'react'
import classnames from 'classnames'

import AdCardListItem from '../../../../../../../features/components/AdCardListItem'
import AdCardMetricSkeleton from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/AdCardMetricSkeleton'
import FacebookAdPreviewSkeleton from '../../../../../../../features/components/FacebookPreviews/reusablePreviewComponents/FacebookAdPreviewSkeleton'

import useAdPreviewStyles from '../../../../../../CampaignsSummary/AdsList/FacebookAdsPreviewList/FacebookAdCardListItem/AdCardPreview/styles'
import useStyles from '../../styles'

function SkeletonOnsiteAdCardListItem() {
  const adPreviewClasses = useAdPreviewStyles({})
  const classes = useStyles()

  return (
    <AdCardListItem>
      <div className={classnames(adPreviewClasses.adPreviewWrapper, classes.adPreviewWrapper)}>
        <FacebookAdPreviewSkeleton renderFooterContent={false} />
      </div>
      <AdCardMetricSkeleton />
      <AdCardMetricSkeleton />
      <AdCardMetricSkeleton />
      <AdCardMetricSkeleton />
      <AdCardMetricSkeleton />
    </AdCardListItem>
  )
}

export default SkeletonOnsiteAdCardListItem
